import { AnyAction } from 'redux';
import produce from 'immer';
import {
  POST_SCHEDULE_RESERVATION_UPDATE_REQUEST,
  POST_SCHEDULE_CANCEL_WAIT_REQUEST,
  POST_SCHEDULE_RESERVATION_UPDATE_SUCCESS,
  POST_SCHEDULE_RESERVATION_UPDATE_FAILURE,
  POST_SCHEDULE_RESERVATION_UPDATE_INITIAL,
} from '../../actions';

export type ScheduleReservationPostType = {
  scheduleReservationPost: {
    isLoading: boolean;
    isLoaded: boolean;
    result: number;
    errorMessage: string | null;
  };
};

const initialState: ScheduleReservationPostType = {
  scheduleReservationPost: {
    isLoading: false,
    isLoaded: false,
    result: 0,
    errorMessage: null,
  },
};

const scheduleReservationPostReducer = (state = initialState, action: AnyAction): ScheduleReservationPostType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case POST_SCHEDULE_RESERVATION_UPDATE_REQUEST:
        dataState.scheduleReservationPost.isLoading = true;
        dataState.scheduleReservationPost.isLoaded = false;
        dataState.scheduleReservationPost.result = initialState.scheduleReservationPost.result;
        dataState.scheduleReservationPost.errorMessage = initialState.scheduleReservationPost.errorMessage;
        break;
      case POST_SCHEDULE_CANCEL_WAIT_REQUEST:
        dataState.scheduleReservationPost.isLoading = true;
        dataState.scheduleReservationPost.isLoaded = false;
        dataState.scheduleReservationPost.result = initialState.scheduleReservationPost.result;
        dataState.scheduleReservationPost.errorMessage = initialState.scheduleReservationPost.errorMessage;
        break;
      case POST_SCHEDULE_RESERVATION_UPDATE_SUCCESS:
        dataState.scheduleReservationPost.isLoading = false;
        dataState.scheduleReservationPost.isLoaded = true;
        dataState.scheduleReservationPost.result = action.data.result;
        dataState.scheduleReservationPost.errorMessage = action.data.errorMessage;
        break;
      case POST_SCHEDULE_RESERVATION_UPDATE_FAILURE:
        dataState.scheduleReservationPost.isLoading = false;
        dataState.scheduleReservationPost.isLoaded = false;
        dataState.scheduleReservationPost.result = -1;
        break;
      case POST_SCHEDULE_RESERVATION_UPDATE_INITIAL:
        dataState.scheduleReservationPost.isLoading = false;
        dataState.scheduleReservationPost.isLoaded = false;
        dataState.scheduleReservationPost.result = 0;
        break;
      default:
        break;
    }
  });
};

export default scheduleReservationPostReducer;
